import { ref,nextTick  } from 'vue';
import homepageService from '@/services/homepageService';
import { useUserStore } from '@/stores/userStore';

export function useNotifications(axios) {
  const userStore = useUserStore();
  const notifications = ref([]);
  const loading = ref(true);
  const error = ref(null);
  const count = ref(0);
  const fetchNotifications = async (id) => {
    try {
      const { data } = await homepageService(axios).getNotifications(id);
      console.log(data)
      notifications.value = data.data;
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };
  const fetchUnreadNotificationsCount = async () => {
    try {
      const { data } = await homepageService(axios).getUnreadNotificationsCount();
      console.log(data,data.data?.length,'notification count');
      count.value = data.data?.length;
      userStore.setCount(data.data?.length);

      userStore.$patch({ count: data.data?.length || 0 });

      await nextTick(); // Ensure Vue updates the UI
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };
  const markReadNotificationsCount = async () => {
    try {
      const { data } = await homepageService(axios).markReadNotificationsCount();
      console.log(data,'readnotificationresult');
      count.value = data.data?.length;
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };

  return {
    notifications,
    loading,
    error,
    fetchNotifications,
    fetchUnreadNotificationsCount,
    markReadNotificationsCount,
    count
  };
}